import PropTypes from 'prop-types';
import MUIRadio from '@material-ui/core/Radio';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { color as themeColor } from '../../app/theme';

const useStyles = makeStyles(
  () => ({
    root: {
      color: themeColor.$11,
      padding: '0 8px',
      '& svg.MuiSvgIcon-root': {
        width: 24,
        height: 24,
      },
    },
  }),
  {
    name: 'Radio',
  },
);

function Radio({ color, ...otherProps }) {
  const classes = useStyles();

  return <MUIRadio className={classes.root} color={color} {...otherProps} />;
}

Radio.defaultProps = {
  color: 'primary',
};

Radio.propTypes = {
  color: PropTypes.string,
};

export default Radio;
